import { FieldType } from '@shared/enums/field-type.enum';
import { FieldGroup } from '@shared/interfaces/field.interface';

export const COMPLETE_INFORMATION_FORM: FieldGroup = {
  CompanyName: {
    type: FieldType.Input,
    label: 'sharedFeatures.CompanyName',
    placeholder: 'sharedFeatures.CompanyNamePlaceholder',
    attrs: { type: 'text' },
  },

  CRNumber: {
    type: FieldType.Input,
    label: 'sharedFeatures.CRNumber',
    placeholder: 'sharedFeatures.CRNumberPlaceholder',
    attrs: { type: 'number' },
  },

  VATNumber: {
    type: FieldType.Input,
    label: 'sharedFeatures.VATNumber',
    placeholder: 'sharedFeatures.VATNumberPlaceholder',
    attrs: { type: 'number' },
  },
};
